import { apiGatewayService } from './apiService/HttpService';
import { setEndPoint } from './apiService/SetEndPoint';
import { endPoints } from './apiService/EndPoints';

class RankingProductsService {
  static rankByType(...extraParams) {
    return apiGatewayService({
      method: 'GET',
      url: setEndPoint(endPoints.rankByType, ...extraParams),
    });
  }
}
export default RankingProductsService;
